import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';
import AccessRightsContext from '../contexts/AccessRightsContext';

import UserContact from './UserContact';

// This is a wrapper class that allows placing the user
// contact in any part of the website. To work properly,
// the following properties must be provided to the User
// Contact:
// - userId
// - treeRootId: scopes the group tree to a specific level of the tree
//   if not present, it will use the user memberships to fetch the groups
// - options hash { displayFullName, displaySkills, groupContextId }
// - access rights hash { admin, read: { contracts, schedule } }

// NOTE: For this wrapper the properties must be explicitly passed from
// either a Parent Component, or directly from Ruby
const UserContactStandalone = props => (
  <Provider store={store}>
    <AccessRightsContext.Provider value={props.accessRights || {}}>
      <UserContact {...props} />
    </AccessRightsContext.Provider>
  </Provider>
);

export default UserContactStandalone;
